@if (isMobile()) {
    <app-mobile-balance
        [loading]="loading"
        [report]="report"
        [company]="company"
        [accordionState]="accordionState"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-mobile-balance>
} @else {
    <app-desktop-balance
        [loading]="loading"
        [accordionState]="accordionState"
        [report]="report"
        [company]="company"
        (handleChangePeriod)="onChangePeriod($event)"
        (handleChangeComparation)="onChangeComparation($event)"
        (handleResetPeriod)="onResetPeriod()"
        [previewMode]="previewMode"
    ></app-desktop-balance>
}
